import { createContext, useContext } from 'react';

export interface FavoritesValue {
  /** Product ids the visitor saved. */
  ids: string[];
  isFavorite: (productId: string) => boolean;
  toggle: (productId: string) => void;
  clear: () => void;
  count: number;
}

export const FavoritesContext = createContext<FavoritesValue | null>(null);

export function useFavorites(): FavoritesValue {
  const value = useContext(FavoritesContext);
  if (!value) throw new Error('useFavorites() precisa ser usado dentro de <FavoritesProvider>.');
  return value;
}
